import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { LeafletModule } from '@bluehalo/ngx-leaflet';
import { SharedModule } from '@suvo/frontend/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/shared/shared.module';
import { HeaderComponent } from '../../../shared/components/header/header.component';
import { SharedModule as MBASharedModule } from '../../../shared/shared.module';
import { PermissionsModule } from '../permissions/permissions.module';
import { ExportCollapsibleComponent } from './components/collapsible/component';
import { ExportTableComponent } from './components/export-table/export-table.component';
import { ExportNestedObjectComponent } from './components/nested-object/component';
import { ExportTableService } from './export-table.service';
import { ExportService } from './export.service';
import { ExportCreateScreenComponent } from './screens/create/export-create-screen.component';
import { ExportListScreenComponent } from './screens/list/export-list-screen.component';
import { ExportViewScreenComponent } from './screens/view/export-view-screen.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    MBASharedModule,
    PermissionsModule,
    LeafletModule,
    MatSidenavModule,
    HeaderComponent,
  ],
  declarations: [
    ExportCollapsibleComponent,
    ExportNestedObjectComponent,
    ExportCreateScreenComponent,
    ExportListScreenComponent,
    ExportTableComponent,
    ExportViewScreenComponent,
  ],
  providers: [ExportService, ExportTableService],
})
export class ExportModule {}
